import { FC } from 'react'

const StopwatchIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4596 4.09069L12.037 3.22441L12.0301 3.21984C12.0786 3.14761 12.1138 3.06486 12.1138 2.97115C12.1138 2.71835 11.909 2.51401 11.6566 2.51401C11.498 2.51401 11.3654 2.59995 11.2832 2.72201L11.2763 2.71744L10.677 3.61618C9.99904 3.27378 9.24795 3.05435 8.45161 2.99401C8.45253 2.98578 8.45664 2.97938 8.45664 2.97115V2.05686H9.37093C9.62327 2.05686 9.82807 1.85252 9.82807 1.59972C9.82807 1.34692 9.62327 1.14258 9.37093 1.14258H6.62807C6.37573 1.14258 6.17093 1.34692 6.17093 1.59972C6.17093 1.85252 6.37573 2.05686 6.62807 2.05686H7.54235V2.97115C7.54235 2.97938 7.54647 2.98578 7.54693 2.99401C4.47675 3.22624 2.05664 5.78441 2.05664 8.91401C2.05664 12.1963 4.71721 14.8569 7.9995 14.8569C11.2818 14.8569 13.9424 12.1963 13.9424 8.91401C13.9424 6.92452 12.9613 5.16818 11.4596 4.09069ZM7.9995 13.9426C5.22235 13.9426 2.97093 11.6911 2.97093 8.91401C2.97093 6.13686 5.22235 3.88544 7.9995 3.88544C10.7766 3.88544 13.0281 6.13686 13.0281 8.91401C13.0281 11.6911 10.7766 13.9426 7.9995 13.9426Z"
      fill="#8E8E93"
      stroke="#8E8E93"
      strokeWidth="0.6"
    />
    <path
      d="M10.2864 6.75317C10.0999 6.56665 9.79731 6.56665 9.61079 6.75317L7.68481 8.55523C7.49829 8.74175 7.49829 9.04438 7.68481 9.23135C7.87132 9.41741 8.17349 9.41741 8.36001 9.23135L10.286 7.42882C10.4725 7.24185 10.4725 6.93968 10.2864 6.75317Z"
      fill="#8E8E93"
      stroke="#8E8E93"
      strokeWidth="0.6"
    />
  </svg>
)

export default StopwatchIcon
